<template>
  <section v-for="(item, index) in couponShowCaseList" :key="index" class="coupon-main-box education-section">
    <div>
      <h3>
        {{ item.head }}
        <br />{{ item.result }}
      </h3>
      <p class="Galyon">
        {{ item.phrase1 }}
        <br />
        <span style="font-size: 19px">
          USE CODE:
          <span class="Galyon-Bold" style="color: #5d8ef9">
            {{ item.couponCode }}
          </span>
        </span>
      </p>
      <input
        type="button"
        class="clip-btn clipped Galyon-Bold"
        value="CLIP COUPON"
          @click="CopyCoupon(item.couponCode)"
      />

      <img
        :src="item.imagePath"
        alt
        style="max-width: 220px; max-height: 120px;"
        class="img-fluid"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { CouponShowCaseModel } from '@/types/Coupon'

export default defineComponent({
  name: 'CouponFeatured',
  props: {
    couponShowCaseList: {
      type: Array as PropType<Array<CouponShowCaseModel>>,
      default: () => { return [] }
    }
  },
  methods: {
    CopyCoupon (code: string) {
      (window as any).CopyCouponCode(code)
    }
  }
})
</script>

<style>
img{border:0;}
input{margin:0;font:inherit;color:inherit;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
input{font-family:inherit;font-size:inherit;line-height:inherit;}
img{vertical-align:middle;}
h3{font-family:inherit;font-weight:500;line-height:1.1;color:inherit;}
h3{margin-top:20px;margin-bottom:10px;}
h3{font-size:24px;}
p{margin:0 0 10px;}
.img-fluid{max-width:100%;height:auto;}
:focus{outline:0;}
input:focus{box-shadow:0 0 0 1px #a6c7fe;-moz-box-shadow:0 0 0 1px #a6c7fe;-webkit-box-shadow:0 0 0 1px #a6c7fe;}
input{margin:0;font:inherit;color:inherit;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
input{font-family:inherit;font-size:inherit;line-height:inherit;}
p{margin:0 0 10px;}
:focus{outline:0;}
input:focus{box-shadow:0 0 0 1px #a6c7fe;-moz-box-shadow:0 0 0 1px #a6c7fe;-webkit-box-shadow:0 0 0 1px #a6c7fe;}
.Galyon{font-family:Galyon, Helvetica, Arial, sans-serif;}
.Galyon-Bold{font-family:"Galyon Bold", Helvetica, Arial, sans-serif;}
.coupon-wrapper p{color:#7a7a7a;font-size:16px;margin:8px 0 0 0;line-height:1.2;}
.clip-btn{width:130px;height:28px;background:#5d8ef9;font-size:13px;border:0;border-radius:50px;color:#fff;cursor:pointer;vertical-align:text-bottom;margin:0 7px;letter-spacing:1px;}
.clip-btn:hover{background:#446ecc;}
@media (max-width: 1200px){
.clip-btn{margin-left:0;}
}
@media (max-width: 540px){
.coupon-wrapper p{font-size:14px!important;}
}
.Galyon{font-family:Galyon, Helvetica, Arial, sans-serif;}
.Galyon-Bold{font-family:"Galyon Bold", Helvetica, Arial, sans-serif;}
.coupon-wrapper h3{font-size:28px;color:#5d8ef9;margin:0;line-height:1.2;}
.coupon-wrapper p{color:#7a7a7a;font-size:16px;margin:8px 0 0 0;line-height:1.2;}
.coupon-main-box{width:100%;border-radius:25px;height:124px;box-shadow:5px 10px 10px 0px #dedede;display:flex;align-items:center;justify-content:center;background:#fff;margin-bottom:35px;padding:0 45px;}
.education-section{position:relative;height:197px;border:2px solid #5d8ef9;justify-content:flex-start;box-shadow:none;margin:0;}
.education-section p{font-size:18px;display:inline-block;color:#474747;line-height:1.5;margin:5px 0 0 0;}
.education-section img{position:absolute;right:20px;bottom:7px;}
.clip-btn{width:130px;height:28px;background:#5d8ef9;font-size:13px;border:0;border-radius:50px;color:#fff;cursor:pointer;vertical-align:text-bottom;margin:0 7px;letter-spacing:1px;}
.clip-btn:hover{background:#446ecc;}
@media (max-width: 1200px){
.education-section p{display:block;}
.clip-btn{margin-left:0;}
.education-section{height:auto;padding:20px 45px;}
.education-section img{width:30%;}
}
@media (max-width: 540px){
.coupon-wrapper h3{font-size:17px;}
.coupon-wrapper p,.education-section p span{font-size:14px!important;}
.coupon-main-box{padding:15px;}
}
</style>
